import styled from 'styled-components'

import { theme } from 'styles/theme'

const { fontSizes, media, colors, space } = theme

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${colors['neutral-background-medium']};
  padding: ${space['spacing-xxl']} 0 ${space['spacing-xxl']} 0;

  @media (${media.tablet}) {
    h2,
    h2 span {
      font-size: ${fontSizes['font-size-heading-2']};
    }
  }

  @media (${media.desktop}) {
    padding: ${space['spacing-giga']} 0 ${space['spacing-giga']} 0;
  }
`

export const PriceRangeContent = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};

  @media (${media.desktop}) {
    gap: ${space['spacing-lg']};
  }
`

export const CardsWrapper = styled.div`
  display: grid;
  gap: ${space['spacing-sm']};

  @media (${media.tablet}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (${media.desktop}) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${space['spacing-md']};
  gap: ${space['spacing-sm']};

  br {
    display: none;
  }

  > button {
    width: 100%;
  }

  @media (${media.desktop}) {
    br {
      display: block;
    }
  }
`
